import React from 'react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import { ArrowWrapper } from './ProductList.styles';

export const ProductListArrow = ({ direction }: { direction: 'left' | 'right' }): JSX.Element => (
  <ArrowWrapper>
    {direction === 'left' ? <MdArrowBack size="16px" /> : <MdArrowForward size="16px" />}
  </ArrowWrapper>
);
